<script>
import AdminLayout from '@layouts/admin-main'
import PolicyInfo from '@components/admin/affiliate-policy-info'
import { fetchPolicies, deletePolicy } from '@apis/admin/affiliate'
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'

export default {
  page: {
    title: 'Admin::AffiliatePolicy',
    meta: [{ name: 'description', content: 'Admin::AffiliatePolicy' }],
  },
  components: {
    AdminLayout,
    PolicyInfo,
  },
  data() {
    return {
      policies: [],
      target_policy_seq: 0,
      show_policy_info: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      Promise.all([this.loadPolicies()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadPolicies() {
      const { data } = await fetchPolicies()

      this.policies = data
    },
    handleCreatePolicy() {
      this.show_policy_info = true
      this.target_policy_seq = null
    },
    handleUpdatePolicy({ seq }) {
      this.show_policy_info = true
      this.target_policy_seq = seq
    },
    handlePolicySubmit(seq) {
      this.init()
      this.target_policy_seq = seq
    },
    async handleDeletePolicy(seq) {
      try {
        if (
          !(await this.$confirm(
            this.$t('admin.confirm_delete'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        await deletePolicy(seq)
        await this.loadPolicies()
      } catch (e) {
        this.$toasted.error(e.message)
      }
    },
    fromPairs,
  },
}
</script>

<template>
  <AdminLayout>
    <h3 :class="$style.xeAdmin">{{ $t('affiliate_policy.management') }}</h3>
    <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
      <thead>
        <tr>
          <th scope="col"
            ><div>{{ $t('affiliate_policy.management') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('affiliate_policy.act') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('affiliate_policy.whether_or_not') }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('affiliate_policy.title') }}</div></th
          >
          <th scope="col">
            <div :class="$style.tRight">
              <a
                href="#"
                :class="[$style.button, $style.black]"
                @click.prevent="handleCreatePolicy"
                ><span>{{ $t('admin.add') }}</span></a
              >
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="policy in policies" :key="policy.seq">
          <td :class="[$style.tCenter, $style.nowrap]">{{
            policy.list_order
          }}</td>
          <td :class="[$style.tCenter, $style.nowrap]">{{
            fromPairs(constants.affiliate.policy.target_action)[
              policy.target_action
            ]
          }}</td>
          <td :class="[$style.tCenter, $style.nowrap]">{{
            policy.is_global
          }}</td>
          <td :class="[$style.wide]">{{ policy.title }}</td>
          <td :class="[$style.tRight, $style.nowrap]">
            <a
              href="#"
              :class="[$style.button]"
              @click.prevent="handleUpdatePolicy(policy)"
              ><span>{{ $t('admin.modify') }}</span></a
            >
            {{ ' ' }}
            <a
              href="#"
              :class="[$style.button, $style.red]"
              @click.prevent="handleDeletePolicy(policy.seq)"
              ><span>{{ $t('admin.delete') }}</span></a
            >
          </td>
        </tr>
        <tr v-if="!policies.length">
          <td :colspan="5" :class="$style.tCenter">{{
            $t('affiliate_policy.msg_no_allowance')
          }}</td>
        </tr>
      </tbody>
    </table>
    <ElDialog
      :title="
        target_policy_seq
          ? $t('affiliate_policy.rectification')
          : $t('affiliate_policy.registration')
      "
      :visible.sync="show_policy_info"
    >
      <PolicyInfo
        v-if="show_policy_info"
        :key="target_policy_seq"
        :policy_seq="target_policy_seq"
        @submit="handlePolicySubmit"
      ></PolicyInfo>
    </ElDialog>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';

.colTable th,
.colTable td {
  vertical-align: middle;
}
.adminRightExtra p {
  margin: 10px 0;
}
</style>
